// TODO: SER-508 - Fix lint errors and remove eslint-disable
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ReactNode } from 'react';

import { msalConfig } from '@/pages/home/content/integration/microsoft/MSALConfig';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

interface MSALProviderProps {
  children: ReactNode;
}

/**
 * MSAL Provider Wrapper
 * This component is used to provide the MSAL instance to the children components
 * The instance is initialized in MSAL Auth component.
 *
 * @param {ReactNode} children - The children components to be provided with the MSAL instance.
 * @returns {ReactNode} - The children components wrapped with the MSAL instance.
 */
export const MSALProviderWrapper = ({ children }: MSALProviderProps) => {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};
